export default __webpack_public_path__ + "static/media/demo1.5d443948.png";